/**
 * Supabase Client Configuration
 *
 * Creates and exports a Supabase client for database operations.
 * Requires REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY environment variables.
 */

import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Only create client if environment variables are present
export const supabase = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;

// Export configuration status for debugging
export const isSupabaseConfigured = !!(supabaseUrl && supabaseAnonKey);

export default supabase;
